<h3>{{ 'CUSTOMERS.PREVIEW_EMAIL.SELECT_TEMPLATE' | translate }}</h3>
<mat-card appearance="outlined">
  <mat-radio-group
    (change)="changeSelectedTemplate($event)"
    [disabled]="isPreviewLoading"
    [(ngModel)]="templateChecked"
    >
    @for (template of templates$ | async; track template; let lastTemplate = $last) {
      <div>
        <div class="template-container">
          <mat-radio-button
            [value]="template"
            color="primary"
            [disabled]="isTemplateDisabled(template)"
            [matTooltip]="getTemplateTooltip(template.templateType) | translate"
            [matTooltipDisabled]="!isTemplateDisabled(template) || isPreviewLoading"
            >
            <div class="template-info">
              @if (template.templateType === ReviewRequestType.email) {
                <mat-icon class="template-icon">email</mat-icon>
              }
              @if (template.templateType === ReviewRequestType.sms) {
                <mat-icon class="template-icon">
                  smartphone
                </mat-icon>
              }
              <div class="template-name">
                {{ template.name }}
              </div>
            </div>
          </mat-radio-button>
          <div>
            @if ((defaultTemplateId$ | async).includes(template.templateId)) {
              <glxy-badge selected [color]="'green'">
                Default
              </glxy-badge>
            }
          </div>
        </div>
        @if (!lastTemplate) {
          <mat-divider [inset]="true"></mat-divider>
        }
      </div>
    }
  </mat-radio-group>
</mat-card>
